<template>
  <fragment>
    <mc-app-header title="Concepts" resource-state="concepts" has-search>
      <template #left>
        <div class="level-item">
          <router-link
            class="button is-small is-primary is-outlined"
            to="/concepts/new"
          >
            Add New
          </router-link>
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="concepts section">
        <mc-paginated-list
          v-slot="{ items: conceptsList }"
          resource-state="concepts"
          has-search
        >
          <div v-if="conceptsList.length === 0" class="box mc-container">
            <div class="content has-text-centered">
              No concepts available!
            </div>
          </div>
          <div v-else class="mc-container">
            <div
              v-for="(concept, index) in conceptsList"
              :key="index"
              class="concepts__item box"
            >
              <div class="concepts__item-desc">
                <div
                  class="concepts__item-title"
                  :class="{
                    'has-tags': !!concept.topicId.name
                  }"
                >
                  {{ concept.name }}
                </div>
                <b-taglist v-if="concept.topicId.name">
                  <b-tag type="is-info">
                    {{ concept.topicId.name }}
                  </b-tag>
                </b-taglist>
              </div>
              <div class="buttons">
                <b-button
                  icon-left="link"
                  class="is-small"
                  @click="addDeepLinkHandler(concept)"
                  >Get Link</b-button
                >
                <router-link
                  class="button is-link is-small"
                  :to="`/concepts/versions/${concept.id}`"
                >
                  Versions
                </router-link>
                <router-link
                  class="button is-link is-small"
                  :to="`/concepts/edit/${concept.id}`"
                >
                  Edit
                </router-link>
              </div>
            </div>
          </div>
        </mc-paginated-list>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { openGetDeepLinkModal } from './getDeepLinkModal';

export default {
  methods: {
    async addDeepLinkHandler(concept) {
      try {
        await openGetDeepLinkModal(this, { concept });
      } catch (e) {
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.concepts {
  height: 100%;

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  &__item-desc {
    flex: 1 0 0;
  }

  &__item-title.has-tags {
    margin-bottom: 0.5rem;
  }
}
</style>
